import { NumberField } from "../NumberField";
import { SPEEDS, fmt } from "../util";
import type { useShowLoader } from "../hooks/useShowLoader";

type Props = {
  showLoader: ReturnType<typeof useShowLoader>;
  bloom: boolean;
  setBloom: React.Dispatch<React.SetStateAction<boolean>>;
  brightness: number;
  setBrightness: React.Dispatch<React.SetStateAction<number>>;
};

/** The panel shown while a real show is loaded: back, transport, speed, glow. */
export function ShowTransport({ showLoader, bloom, setBloom, brightness, setBrightness }: Props) {
  const { show, closeShow, playing, setPlaying, speed, setSpeed, nowLabel, sliderRef, playhead } = showLoader;
  if (!show) return null;

  return (
    <>
      <div className="panel-row show-head">
        <button className="chip" onClick={closeShow}>← Studio</button>
        <div className="show-name">
          {show.name}
          <span>{show.droneCount} drones · {show.Fp.toLocaleString()} pos · {show.Fc.toLocaleString()} color frames</span>
        </div>
      </div>
      <div className="panel-row transport">
        <button className="chip play" onClick={() => setPlaying((p) => !p)}>{playing ? "❚❚" : "►"}</button>
        <span className="clock">{nowLabel}</span>
        <input
          ref={sliderRef}
          className="scrub"
          type="range"
          min={0}
          max={show.durationSec}
          step={0.05}
          defaultValue={0}
          onInput={(e) => { playhead.current = +e.currentTarget.value; }}
        />
        <span className="clock dim">{fmt(show.durationSec)}</span>
      </div>
      <div className="panel-row controls">
        <span className="slider-label">Speed</span>
        {SPEEDS.map((s) => (
          <button key={s} className={"chip speed" + (s === speed ? " active" : "")} onClick={() => setSpeed(s)}>{s}×</button>
        ))}
        <button className={"chip toggle" + (bloom ? " active" : "")} onClick={() => setBloom((b) => !b)}>Bloom</button>
        <NumberField label="Glow" value={brightness} min={0.6} max={2.6} step={0.05} onChange={(v) => setBrightness(v)} format={(v) => v.toFixed(2)} />
      </div>
    </>
  );
}
